import React from 'react'
import { Col, Row } from 'antd'

import styles from './ConvertSteps.module.sass'

const ConvertSteps = ({ fromFile, toFile, title, action }) => {
  return (
    <section className={styles.info}>
      <div className='container'>
        <Row justify='center'>
          <Col xs={24}>
            {/* <h3 className={styles.info_heading}>How to Convert a <span>{fromFile || 'ACC'}</span> to <span>{toFile || 'MP3'}</span> File?</h3> */}
            <h3 className={styles.info_heading}>{title}</h3>
          </Col>
        </Row>
        <Row justify='center' gutter={{ xs: 0, sm: 32, md: 64 }}>
          <Col xs={24} sm={8} md={6} className={styles.info_item}>
            <img src={'/images/icon_audio_step_1.png'} srcSet='/images/icon_audio_step_1@2x.png 2x' alt='choose file' />
            <div>
              <span className={styles.info_step}>1</span>
              <div className={styles.info_text}>
                Choose the <span>{fromFile}</span> file that you want to {action.toLowerCase()}.
              </div>
            </div>
          </Col>
          <Col xs={24} sm={8} md={6} className={styles.info_item}>
            <div className={styles.info_step_2}>
              <div className={styles.info_step_2_top}>
                <span className={styles.red} />
                <span className={`${styles.red} ${styles.yellow}`} />
                <span className={`${styles.red} ${styles.green}`} />
              </div>
              <div className={styles.info_step_2_center}>
                <div className='pos-relative text-left'>
                  <span>{toFile || 'MP3'}</span>
                  <div className={styles.info_step_2_arrow_down}/>
                </div>
              </div>
            </div>
            {/* <img src={require('public/images/icon_audio_step_2.png')} srcSet='/images/icon_audio_step_2@2x.png 2x' alt='choose file' /> */}
            <div>
              <span className={styles.info_step}>2</span>
              <div className={styles.info_text}>
                Select <span>{toFile}</span> as the the format you want to {action.toLowerCase()} your <span>{fromFile}</span> file to.
              </div>
            </div>
          </Col>
          <Col xs={24} sm={8} md={6} className={styles.info_item}>
            <div className={styles.info_step_2}>
                <div className={styles.info_step_2_top}>
                  <span className={styles.red} />
                  <span className={`${styles.red} ${styles.yellow}`} />
                  <span className={`${styles.red} ${styles.green}`} />
                </div>
                <div className={`${styles.info_step_2_center} ${styles.step_3}`}>
                  <img src={'/images/convert_logo_icon.svg'} alt="logo" />
                  {action}
                </div>
              </div>
            {/* <img src={require('public/images/icon_audio_step_3.png')} srcSet='/images/icon_audio_step_3@2x.png 2x' alt='choose file' /> */}
            <div>
              <span className={styles.info_step}>3</span>
              <div className={styles.info_text}>
                {`Click '${action}' to `} {action.toLowerCase()} your <span>{fromFile}</span> file
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </section>

  )
}

export default ConvertSteps
